import { SmithWaite } from './SmithWaite.js';
import { AcesHigh } from './Standard.js';
export var DeckCode;
(function (DeckCode) {
    DeckCode["TarotSW"] = "swtd";
    DeckCode["AcesHigh"] = "stdah";
})(DeckCode || (DeckCode = {}));
export const decks = {
    [DeckCode.TarotSW]: SmithWaite,
    [DeckCode.AcesHigh]: AcesHigh,
};
export const getDeckCode = (param) => {
    return param?.deckCode || param;
};
export const getDeck = (param) => {
    const deckCode = getDeckCode(param);
    return decks[deckCode];
};
export const getCard = (param, cardRef) => {
    const deckCode = getDeckCode(param);
    const deck = getDeck(deckCode);
    if (!deck || cardRef < 0 || cardRef >= deck.cards.length) {
        throw new Error(`cardRef ${cardRef} not valid for deck ${deckCode}`);
    }
    return deck.cards[cardRef];
};
export const getCardRef = (deckParam, cardValue, suitName) => {
    const deck = deckParam.cards
        ? deckParam
        : getDeck(deckParam);
    const cardRef = deck.cards.findIndex((card) => card.cardValue === cardValue && card.suit.suitName === suitName);
    if (cardRef === -1) {
        throw new Error(`getCardRef - could not find card suit ${suitName} value ${cardValue}`);
    }
    return cardRef;
};
export function shuffle(deckCode) {
    const deck = getDeck(deckCode);
    const indices = deck.cards.map((_card, idx) => idx);
    var randomNumbers = indices.map(Math.random);
    return indices.sort((a, b) => {
        return randomNumbers[a] - randomNumbers[b];
    });
}
//# sourceMappingURL=Decks.js.map